import React from "react";

const BombaElectrica = ({ circleColor, ...props }) => (
  <svg
    width={126}
    height={121}
    fill="none"
    {...props}>
    <path
      fill="#293741"
      d="M48.692 90.074c.221.027.445.029.666.006l18.166-1.88c.29-.03.575-.102.845-.214l5.21-2.17a3 3 0 0 1 3.605 1.04l20.144 28.568c1.4 1.987-.02 4.728-2.452 4.728H5.612c-2.397 0-3.826-2.673-2.494-4.666l19.14-28.65a3 3 0 0 1 3.504-1.159l6.62 2.365c.212.075.43.127.652.153l15.658 1.88ZM46 3.548A3.548 3.548 0 0 1 49.548 0H121a5 5 0 0 1 5 5v21a5 5 0 0 1-5 5H96.734a5 5 0 0 1-3.05-1.038L71.985 13.264a5 5 0 0 0-1.832-.887L48.684 6.988A3.548 3.548 0 0 1 46 3.548Z"
    />
    <path
      fill="#293741"
      d="M99.306 49.628c0 27.409-22.22 49.628-49.628 49.628C22.269 99.256.05 77.037.05 49.628S22.27 0 49.678 0c27.409 0 49.628 22.22 49.628 49.628Zm-88.671 0c0 21.563 17.48 39.043 39.043 39.043S88.72 71.191 88.72 49.628 71.24 10.585 49.678 10.585s-39.043 17.48-39.043 39.043Z"
    />
    <circle
      cx={49.678}
      cy={49.628}
      r={28.732}
      fill={circleColor}
    />
  </svg>
);

export { BombaElectrica };
